import { useAppContext } from "src/shared/context/AppContext";
import {
  DiscoveryContainer,
  FirstRowContainer,
  NavContainer,
} from "src/website-apps/shared/components/header/SearchEmphasizedBrowseHeader/styled-components";
import { NavBackdropProvider } from "src/website-apps/shared/components/header/t-home-rebuild-nav/HeaderNav/NavBackdropContext";
import { isPerformerPage } from "src/website-apps/shared/utils/isPerformerPage";

export const FirstRow = ({ logo, mainNav, icon, discoveryNav }) => {
  const appContext = useAppContext();

  return (
    <NavBackdropProvider>
      <FirstRowContainer>
        {logo()}
        <DiscoveryContainer>{!isPerformerPage(appContext) && discoveryNav && discoveryNav()}</DiscoveryContainer>
        <NavContainer>
          {mainNav()}
          {icon()}
        </NavContainer>
      </FirstRowContainer>
    </NavBackdropProvider>
  );
};
